/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_Document_PrepInputs */

const cs_enum_document_prep = /** @type {(inputs: Enum_Document_PrepInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Příprava dokumentů`)
};

const en_enum_document_prep = /** @type {(inputs: Enum_Document_PrepInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Document prep`)
};

/**
* | output |
* | --- |
* | "Document prep" |
*
* @param {Enum_Document_PrepInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_document_prep = /** @type {((inputs?: Enum_Document_PrepInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_Document_PrepInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_document_prep(inputs)
	return cs_enum_document_prep(inputs)
});